/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IStoreSelectorButtonData } from './store-selector-button.data';
import { IStoreSelectorButtonProps } from './store-selector-button.props.autogenerated';

export interface IStoreSelectorButtonViewProps extends IStoreSelectorButtonProps<IStoreSelectorButtonData> {}

/**
 *
 * StoreSelectorButton component
 * @extends {React.PureComponent<IStoreSelectorButtonProps<IStoreSelectorButtonData>>}
 */
class StoreSelectorButton extends React.PureComponent<IStoreSelectorButtonProps<IStoreSelectorButtonData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default StoreSelectorButton;
